import { render, staticRenderFns } from "./GeneralNotifications.vue?vue&type=template&id=2b8ecc7a&"
import script from "./GeneralNotifications.vue?vue&type=script&lang=js&"
export * from "./GeneralNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports